'use strict';

module.exports = {
  all: 'all',
};
